import { render, staticRenderFns } from "./volunteerPreliminary.vue?vue&type=template&id=345dda8a&scoped=true"
import script from "./volunteerPreliminary.vue?vue&type=script&lang=js"
export * from "./volunteerPreliminary.vue?vue&type=script&lang=js"
import style0 from "./volunteerPreliminary.vue?vue&type=style&index=0&id=345dda8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345dda8a",
  null
  
)

export default component.exports